<template>
  <BaseVeeForm
    :action="submitForm"
    v-slot="{ isPending, isRejected, invalid }"
    @success="$emit('success')"
    @failure="$emit('failure')"
  >
    <BaseCard>
      <BaseCardBody>
        <BaseHeading :level="2" class="mb-4"> Reset password </BaseHeading>
        <p class="text-gray-600 mb-8">
          Enter the email associated with your account and we will send an email with instructions
          to reset your password.
        </p>
        <div class="space-y-6">
          <ValidationProvider rules="required" name="email" tag="div" vid="email">
            <template #default="{ errors, failed }">
              <BaseFormGroup>
                <BaseFormLabel for="email"> Email address </BaseFormLabel>
                <BaseFormInput
                  id="email"
                  type="email"
                  v-model="formData.email"
                  :disabled="isPending"
                />
                <BaseFormInlineMessage v-if="failed" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </template>
          </ValidationProvider>
        </div>
      </BaseCardBody>
      <BaseCardBody>
        <BaseButton primary class="w-full" :disabled="invalid || isPending || isRejected">
          Send instructions
        </BaseButton>
      </BaseCardBody>
    </BaseCard>
  </BaseVeeForm>
</template>

<script>
export default {
  name: 'PasswordResetRequestForm',

  data() {
    return {
      formData: {
        email: '',
      },
    };
  },

  methods: {
    async submitForm() {
      const {
        $store: { dispatch },
        formData,
      } = this;

      try {
        const response = await dispatch({
          type: 'ui/auth/sendPasswordResetEmail',
          formData,
        });

        this.$emit('success', response);

        return Promise.resolve(response);
      } catch (error) {
        this.$emit('failure', error);
        return Promise.reject(error);
      }
    },
  },
};
</script>
